import axios from "./axiosInstance";

const privacyPolicyApi = {
  details: () => axios.post("privacy-policy"),
};

export default privacyPolicyApi;
